/* UserIconComponent template */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { UserIconComponent } from './cwc-user-icon';

/**
 * Definition of  parameters that the template needs to work.
 */
interface UserIconTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: UserIconComponent;
  version: string;
  loggedIn: boolean;
  showModal: boolean;
  textLoggedIn: string;
  // Specify parameters that are required to be passed down to the template here.
}

const UserIconTemplate: FunctionalComponent<UserIconTemplateProps> = ({
  controller,
  version,
  loggedIn,
  showModal,
  textLoggedIn,
}) => (
  <Host>
    <div
      onClick={() => controller.onIconClicked()}
      onKeyDown={(event: KeyboardEvent) => controller.onKeyDown(event)}
      tabindex={0}
      class={'pointer'}
    >
      <div class="wrap" data-version={version}>
        <slot name={'svg'}></slot>
        <div class={'bubble ' + (loggedIn ? '' : 'hide')} aria-live={'polite'} aria-label={textLoggedIn}>
          <slot name={'tick-svg'}></slot>
        </div>
      </div>
    </div>
    <cwc-component-modal opened={showModal} id="user-icon-modal" class={showModal ? '' : 'hide'}>
      <slot name={'modal-header'} slot="header-items"></slot>
      <div class={loggedIn ? '' : 'hide'}>
        <slot name={'modal-body-logged-in'}></slot>
      </div>
      <div class={loggedIn ? 'hide' : ''}>
        <slot name={'modal-body-logged-out'}></slot>
      </div>
      <div class={'buttons'} slot="footer-items">
        <div class={'button ' + (loggedIn ? 'hide' : '')} onClick={() => controller.goToLogin(true)}>
          <slot name={'modal-footer-button-login'}></slot>
        </div>
        <div class={'button ' + (loggedIn ? '' : 'hide')} onClick={() => controller.logout()}>
          <slot name={'modal-footer-button-logout'}></slot>
        </div>
        <div class={'button'} onClick={() => controller.goToLogin(false)}>
          <slot name={'modal-footer-button-my-account'}></slot>
        </div>
      </div>
    </cwc-component-modal>
  </Host>
);

export default UserIconTemplate;
